// extracted by mini-css-extract-plugin
export default {"header":"FilterBar_header__jbqFL"};